import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { ICountryFromApi, ICountry } from "@models/interfaces/index";
import { Observable } from "rxjs";
import { ConfigService } from "@shared/config/services/config.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class CountriesService {
    public constructor(
        private http: HttpClient,
        private readonly config: ConfigService,
    ) {}

    public getAllCountries(): Observable<ICountry[]> {
        const url: string = `${this.config.get("apiCountries")}`;

        return this.http
            .get(url)
            .pipe(
                map((data: ICountryFromApi) => data.data.filter((data: ICountry) => data.destinations !== undefined)),
            );
    }
}
